import React from "react";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { MaskedHeading, Fade, FadeUp } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { useContent } from "@/context/ContentContext";
import { telHref, mailHref } from "@/lib/content";
import usePageMeta from "@/lib/usePageMeta";

export default function Contact() {
  const { contact } = useContent();
  usePageMeta({
    title: "Kontakt",
    description:
      "Book et uforpligtende inspirationsmøde med Hagelund. Ring 22 56 14 15 eller send en besked — vi vender tilbage hurtigst muligt.",
    path: "/kontakt",
  });
  return (
    <div data-testid="contact-page">
      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pt-36 md:pt-48 pb-12 md:pb-16">
        <Fade>
          <p className="text-xs uppercase tracking-label text-accent mb-6">Kontakt</p>
        </Fade>
        <h1 className="font-display font-light leading-[0.9] text-5xl sm:text-7xl md:text-[7rem] tracking-tight max-w-5xl">
          <MaskedHeading lines={["Få et inspirations-", "møde"]} delay={0.2} />
        </h1>
        <FadeUp delay={0.3}>
          <p className="mt-8 text-muted-foreground font-light text-lg max-w-2xl">
            Fortæl os lidt om dit hus og dine ønsker. Vi vender tilbage og aftaler et uforpligtende møde, hvor vi rådgiver ud fra netop din bolig.
          </p>
        </FadeUp>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pb-32 md:pb-48">
        <div className="grid md:grid-cols-12 gap-12 md:gap-20 items-start">
          <div className="md:col-span-7 order-2 md:order-1">
            <FadeUp>
              <LeadForm source="Website" page="Kontakt" />
            </FadeUp>
          </div>

          <div className="md:col-span-4 md:col-start-9 order-1 md:order-2">
            <FadeUp delay={0.1}>
              <div className="space-y-8">
                <a href={telHref(contact.phone)} data-testid="contact-phone" className="group flex items-start gap-4">
                  <Phone size={22} weight="light" className="text-accent mt-1" />
                  <div>
                    <p className="text-xs uppercase tracking-label text-muted-foreground mb-1">Telefon</p>
                    <p className="font-display text-3xl font-light group-hover:text-accent transition-colors">{contact.phone}</p>
                  </div>
                </a>
                <a href={mailHref(contact.email)} data-testid="contact-email" className="group flex items-start gap-4">
                  <EnvelopeSimple size={22} weight="light" className="text-accent mt-1" />
                  <div>
                    <p className="text-xs uppercase tracking-label text-muted-foreground mb-1">E-mail</p>
                    <p className="font-display text-2xl font-light break-all group-hover:text-accent transition-colors">{contact.email}</p>
                  </div>
                </a>
                <div className="flex items-start gap-4">
                  <MapPin size={22} weight="light" className="text-accent mt-1" />
                  <div>
                    <p className="text-xs uppercase tracking-label text-muted-foreground mb-1">Adresse</p>
                    <p className="font-light text-lg">{contact.address}</p>
                    <p className="text-muted-foreground font-light mt-1">CVR {contact.cvr}</p>
                  </div>
                </div>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>
    </div>
  );
}
